<template>
    <div class="card" @click="handleRouterSkip" :class="{'mar_r_0':(index+1)%3==0}">
        <img :src="item.Cover" alt="">
        <h2>{{item.Title}}</h2>
        <p>{{item.Summary}}</p>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => { return {} }
        },
        index: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {}
    },
    created() {
    },
    methods: {
        handleRouterSkip() {
            this.$router.push({ name: 'Details', query: { id: this.item.NewsID } })
        },

    }
}
</script>

<style lang="scss" scoped>
.mar_r_0 {
    margin-right: 0px !important;
}
.card:hover {
    opacity: 0.8;
}
.card {
    width: 380px;
    height: 402px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    margin-right: 30px;
    margin-bottom: 32px;
    cursor: pointer;
    & img {
        width: 100%;
        height: 246px;
    }
    & h2 {
        margin: 32px 0 16px;
        color: #000000;
        line-height: 32px;
        padding: 0 24px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    & h2:hover {
        color: #ff9200;
    }
    & p {
        height: 44px;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        padding: 0 24px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        -webkit-box-orient: vertical;
        box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2; //显示的行数
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>